// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-grid {
    display: grid;
    gap: 12px;
}

.form-row {
    display: grid;
    gap: 6px;
}

.form-label {
    font-size: 12px;
    opacity: 0.8;
}

.form-input {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    border-radius: 10px;
}

.form-error {
    margin-top: 8px;
    font-size: 16px;
    color: #b00020;
}

.selected-summary,
.card-number {
    padding: 10px 12px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 12px;
}

.summary-line {
    display: flex;
    gap: 8px;
}

.summary-label {
    font-size: 12px;
    opacity: 0.7;
    min-width: 90px;
}

.summary-value {
    font-size: 13px;
    font-weight: 600;
}

.nec-stack {
    display: flex;
    flex-direction: column;
    gap: 30px;
}

.nec-block {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.nec-header {
    font-weight: 700;
    font-size: 16px;
    color: #013868;
    margin-bottom: 8px;
}

.nec-control {
    width: 100%;
    border-radius: 8px;
}

.nec-input {
    width: 100%;
    height: 38px;
    padding: 25px;
    padding-left: 15px;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0);
    background: #eef3f7;
    outline: none;
    font-size: 16px;
}

.nec-input:focus {
    border-color: rgba(11, 78, 162, 0.45);
    box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);
}

.nec-hint {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
}

.nec-inline {
    display: flex;
    gap: 8px;
    align-items: center;
}

.nec-pill {
    display: inline-flex;
    align-items: center;
    height: 26px;
    padding: 0 10px;
    border-radius: 999px;
    background: rgba(11, 78, 162, 0.08);
    color: #0b4ea2;
    font-weight: 600;
    font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/AppUser/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,kCAAkC;IAClC,mBAAmB;IACnB,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mCAAmC;IACnC,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB","sourcesContent":[".form-grid {\r\n    display: grid;\r\n    gap: 12px;\r\n}\r\n\r\n.form-row {\r\n    display: grid;\r\n    gap: 6px;\r\n}\r\n\r\n.form-label {\r\n    font-size: 12px;\r\n    opacity: 0.8;\r\n}\r\n\r\n.form-input {\r\n    width: 100%;\r\n    padding: 10px 12px;\r\n    border: 1px solid rgba(0, 0, 0, 0.15);\r\n    border-radius: 10px;\r\n}\r\n\r\n.form-error {\r\n    margin-top: 8px;\r\n    font-size: 16px;\r\n    color: #b00020;\r\n}\r\n\r\n.selected-summary,\r\n.card-number {\r\n    padding: 10px 12px;\r\n    border: 1px solid rgba(0, 0, 0, 0.08);\r\n    border-radius: 12px;\r\n}\r\n\r\n.summary-line {\r\n    display: flex;\r\n    gap: 8px;\r\n}\r\n\r\n.summary-label {\r\n    font-size: 12px;\r\n    opacity: 0.7;\r\n    min-width: 90px;\r\n}\r\n\r\n.summary-value {\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n}\r\n\r\n.nec-stack {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 30px;\r\n}\r\n\r\n.nec-block {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n}\r\n\r\n.nec-header {\r\n    font-weight: 700;\r\n    font-size: 16px;\r\n    color: #013868;\r\n    margin-bottom: 8px;\r\n}\r\n\r\n.nec-control {\r\n    width: 100%;\r\n    border-radius: 8px;\r\n}\r\n\r\n.nec-input {\r\n    width: 100%;\r\n    height: 38px;\r\n    padding: 25px;\r\n    padding-left: 15px;\r\n    border-radius: 8px;\r\n    border: 1px solid rgba(0, 0, 0, 0);\r\n    background: #eef3f7;\r\n    outline: none;\r\n    font-size: 16px;\r\n}\r\n\r\n.nec-input:focus {\r\n    border-color: rgba(11, 78, 162, 0.45);\r\n    box-shadow: 0 0 0 3px rgba(11, 78, 162, 0.12);\r\n}\r\n\r\n.nec-hint {\r\n    font-size: 14px;\r\n    color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.nec-inline {\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n}\r\n\r\n.nec-pill {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    height: 26px;\r\n    padding: 0 10px;\r\n    border-radius: 999px;\r\n    background: rgba(11, 78, 162, 0.08);\r\n    color: #0b4ea2;\r\n    font-weight: 600;\r\n    font-size: 12px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
